const generationArr = [
    {
      gen:"I",
      img:[1,4,7]
    },{
      gen:"II",
      img:[152,155,158]
    },{
      gen:"III",
      img:[252,255,258]
    },{
      gen:"IV",
      img:[387,390,393]
    },{
      gen:"V",
      img:[495,498,501]
    },{
      gen:"VI",
      img:[650,653,656]
    },{
      gen:"VII",
      img:[722,725,728]
    },{
      gen:"VIII",
      img:[810,813,816]
    }
  ]

  export default generationArr